import React from 'react';
import { PawPrint, Check } from 'lucide-react';
import { Reveal } from '../Reveal';
import { CtaButton } from '../CtaButton';
import { siteConfig } from '../../data/siteConfig';
export function FinalCtaSection() {
  const notes = ['Acceso inmediato', 'Pago único', `Garantía ${siteConfig.guaranteeDays} días`];
  return <section className="bg-forest pb-[110px] pt-24 text-center text-cream" data-id="element-31" data-mp="2dibrz43eet96">
      <Reveal className="mx-auto max-w-[1120px] px-5" data-id="element-32" data-mp="2rimejuxodloj">
        <div className="mb-5 flex items-center justify-center gap-2.5 font-display text-[15px] font-extrabold tracking-[0.16em] text-tangerine-light" data-id="element-33" data-mp="2rh1mcbyu2etu">
          <PawPrint className="h-[22px] w-[22px]" fill="currentColor" aria-hidden="true" data-id="element-34" data-mp="3197d5idcmq7g" />
          PASEO PRO
        </div>
        <h2 className="mx-auto max-w-[900px] text-[32px] font-extrabold leading-[1.08] md:text-[52px]" data-id="element-35" data-mp="2wacwalyxzbpz">
          Tu próximo cliente decide en <em className="not-italic text-tangerine-light" data-id="element-36" data-mp="3a79i2907e300">5 minutos</em> si
          confía en ti.
        </h2>
        <p className="mx-auto mb-[34px] mt-[18px] max-w-[640px] text-[19px] text-forest-soft" data-id="element-37" data-mp="220ksv4r9o6bc">
          Hazlo con un contrato, una ficha, precios claros y unas redes activas. Todo listo hoy, por{' '}
          <b className="text-white" data-id="element-38" data-mp="2b1ivpjpyy7sc">{siteConfig.price}</b>, con {siteConfig.guaranteeDays} días de
          garantía.
        </p>
        <CtaButton size="lg" data-id="element-39" data-mp="2g1dmln9quxde">Quiero mi kit PASEO PRO ahora</CtaButton>
        <ul className="mt-[18px] flex flex-wrap justify-center gap-x-4 gap-y-1.5 text-[13.5px] text-forest-soft" data-id="element-40" data-mp="2kzow1ww4n5v3">
          {notes.map(n => <li key={n} className="inline-flex items-center gap-1.5" data-id="element-41" data-mp="2ozh8wlsjzy69">
              <Check className="h-4 w-4 text-tangerine-light" aria-hidden="true" data-id="element-42" data-mp="2trh27ve4bstv" />
              {n}
            </li>)}
        </ul>
      </Reveal>
    </section>;
}